import {css, StyleSheet} from 'aphrodite';
import React from 'react';

import {LEGACY_FONT_PROXIMA_TITLE} from 'styles/FontConstants';
import {ButtonSize} from 'ui-library/buttons/Button';
import {NEAR_BLACK} from 'ui-library/Colors';
import SelectDropdown from 'ui-library/dropdowns/SelectDropdown';
import Menu from 'ui-library/menus/Menu';
import {MenuHeight, MenuWidth, OptionData} from 'ui-library/menus/MenuConstants';
import Option from 'ui-library/menus/Option';

interface MultiquerySelectorProps {
  groupBySelection?: string;
  setGroupBySelection: (selection: string) => void;
  groupIds: Array<string>;
}

export default function MultiquerySelector(props: MultiquerySelectorProps): JSX.Element {
  if (props.groupBySelection == null) {
    props.setGroupBySelection(props.groupIds[0]);
  }

  const values = props.groupIds;

  const optionDatas: Array<OptionData> = values.map((value) => ({
    name: value,
    value,
    dataTestAttrs: {
      component: 'DropdownSelector',
      element: 'option',
      key: value,
    },
  }));

  const menu = (
    <Menu scrollable={true} height={MenuHeight.LARGE} width={MenuWidth.XXLARGE}>
      {optionDatas.map((optionData, i) => (
        <Option
          key={i}
          onSelect={() => {
            // onChange(optionData.value);
            props.setGroupBySelection(optionData.value);
          }}
          value={optionData.value}
          dataTestAttrs={optionData.dataTestAttrs}
        >
          {optionData.name}
        </Option>
      ))}
    </Menu>
  );

  const headerString = 'Showing results for';

  return (
    <div className={css(styles.container)}>
      <div className={css(styles.headerRow)}>{headerString}</div>
      <SelectDropdown
        className={css(styles.selectDropdown)}
        buttonSize={ButtonSize.SMALL}
        displayName={props.groupBySelection}
        menu={menu}
      />
    </div>
  );
}

const styles = StyleSheet.create({
  container: {
    display: 'flex',
    flexDirection: 'column',
  },
  selectDropdown: {
    width: '200px',
  },
  headerRow: {
    ...LEGACY_FONT_PROXIMA_TITLE,
    color: NEAR_BLACK,
  },
});
